<template>
    <div class="editReservationPopupBg" @click.self="closeSubModal">
        <div class="popupArea bg-lightest p-3">

            <div class="text-center fs-larger font-weight-600 p-3">
                Add Extras
            </div>

            <add-extras class="extrasHolder" :reservation="getSelectedReservation"></add-extras>

            <div class="col-sm-12 my-2">
                <div class="row w-100 d-flex justify-content-between align-items-end">
                    <div v-if="loadingPeopleFinancials">
                        <loader></loader>
                    </div>
                    <div class="d-flex col-8 p-0" v-else>
                        <div class="col-8 p-0 mr-3">
                            <label>Selected seller</label>
                            <seller-picker
                                class="w-100"
                                ref="sellerSelector"
                                :allowEmpty="false"
                                :inlcudeWidget="true"
                                :orignalSeller="selectedSeller"
                                :hideAllByChannel="true"
                                @input="sellerChanged"
                                @deselect="deselectSeller"
                                openDirection="top">
                            </seller-picker>
                        </div>
                        <div class="ml-2" v-if="selectedSellerCommissions">
                            <label>Commission</label>
                            <div class="d-flex bold pt-2">{{selectedSellerCommissions.commissionComponentValue}}{{selectedSellerCommissions.commissionComponentValueType == 1? '%':'€'}}</div>
                        </div>
                    </div>
                    <div>
                        <button class="btn primary wider ml-2" :disabled="loadingPeopleFinancials" @click="pressDone">Done</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { reservationsMixin } from '@/mixins/reservations'
import extendedVSelect from '@/extends/vue-select'
import SellerPicker from '../../../tools/SellerPicker'
import Loader from '@/tools/loaders/loader1'
import AddExtras from '@/components/reservations/NewReservation/Resume/AddExtra/AddExtra'

export default {
    data() {
        return {
            selectedSeller: null,
        }
    },
    created() {
        this.selectedSeller = JSON.parse(JSON.stringify(this.account));
        this.downloadSelectedProductCommissions(this.getSelectedReservation.event.product.id);

        // Set the correct seller if there are unsaved added extras
        this.setExtrasOwner();
    },
    computed: {
        ...mapGetters([
            'getSelectedReservation',
            'account',
            'getSelectedProductCommissions',
            'getIsLoadingPeopleFinancials',
            'getTeam',
            'getAgents'
        ]),
        peopleFinancials() {
            return this.getSelectedProductCommissions;
        },
        loadingPeopleFinancials() {
            return this.getIsLoadingPeopleFinancials;
        },
        selectedSellerCommissions() {
            let seller = this.selectedSeller;
            if (seller.userAccountTypeDefault || seller.supplier) {
                // MyTeam or Sales Channel
                return this.peopleFinancials.filter(financialRow => {
                    return financialRow.accountType == 2 && financialRow.userAccount.id == seller.id;
                })[0];
            } else {
                // Agent
                return this.peopleFinancials.filter(financialRow => {
                    return financialRow.accountType == 1 && financialRow.agent.id == seller.id;
                })[0];
            }
        },
    },
    mixins: [
        reservationsMixin
    ],
    methods: {
        ...mapActions([
            'downloadSelectedProductCommissions'
        ]),
        setExtrasOwner() {
            if (this.hasUnsavedExtras()) {
                let sampleExtra = this.getSelectedReservation.bookingComponents.filter(unsavedExtra => {
                    return unsavedExtra.id == null;
                })[0];

                if (!sampleExtra) return;

                if (sampleExtra.creatorUserAccount) {
                    this.selectedSeller = this.getTeam.filter(teamMember => {return teamMember.id == sampleExtra.creatorUserAccount.id})[0];
                } else if (sampleExtra.creatorAgent) {
                    this.selectedSeller = this.getAgents.filter(agent => {return agent.id == sampleExtra.creatorAgent.id})[0];
                }
            }
        },
        hasUnsavedExtras() {
            if (this.getSelectedReservation.event.eventComponents && this.getSelectedReservation.event.eventComponents.length > 0) {
                return this.getSelectedReservation.event.eventComponents.filter(extra => {
                    return extra.quantityToAdd > 0;
                }).length > 0;
            } else {
                return false;
            }
        },
        closeSubModal() {
            this.eventHub.$emit('editReservation_toggleAddExtras', 'close');
        },
        pressDone() {
            this.$set(this.selectedSeller, 'commissionData', this.selectedSellerCommissions);
            this.eventHub.$emit('editReservation_toggleAddExtras', this.selectedSeller);
        },
        sellerChanged(selection) {
            this.selectedSeller = selection;
            if (this.selectedSeller.userAccountTypeDefault && this.selectedSeller.userAccountTypeDefault.supplier) {
                this.selectedSeller.supplier = this.selectedSeller.userAccountTypeDefault.supplier;
                this.selectedSeller.supplierId = this.selectedSeller.userAccountTypeDefault.supplierId;
            }
        },
        deselectSeller() {}
    },
    components: {
        vSelect: extendedVSelect,
        AddExtras,
        SellerPicker,
        Loader,
    }
}
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/_variables.scss';

    .extrasHolder {
        max-height: 370px;
        overflow-y: auto;
    }

    .editReservationPopupBg {
        background-color: rgba(0,0,0,0.5);
        width: 100%;
        height: 100%;
        z-index: 10;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;

        .popupArea {
            width: 1000px;
            max-height: 100%;
            max-width: 100%;
            margin: 0 auto;
        }
    }
</style>



// WEBPACK FOOTER //
// AddExtras.vue?54c3592a